import React from "react";
import Skills from "../components/Skills/Skills";

const SkillsPage: React.FC = () => {
  return <Skills />;
};

export default SkillsPage;
